// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import moment from 'moment';    //JavaScript 日期处理类库
moment.locale('zh-cn');

import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VClamp from 'vue-clamp'
import 'babel-polyfill' //兼容ie
import './assets/style/common.less'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import 'swiper/swiper-bundle.css'

import Vuex from 'vuex'
import store from './store'//引入store

import 'animate.css';

import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);

Vue.use(UmyUi);

Vue.config.productionTip = false
Vue.component('VClamp', VClamp);
Vue.use(ElementUI);
Vue.prototype.$moment = moment;
Vue.prototype.$getWordNum = (html)=>{
  html = html.replace(/<xml>[\s\S]*?<\/xml>/ig, '') 
  html = html.replace(/<style>[\s\S]*?<\/style>/ig, '') //去css代码
  html = html.replace(/<\/?[^>]*>/g, '')  //去html标签
  html = html.replace(/[ | ]*\n/g, '\n')
  html = html.replace(/&nbsp;/ig, ''); //空格算一个字
  return html;
};
Vue.use(Vuex)
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Vue.use(VueSlickCarousel);
Vue.prototype.$iPhoneType = false;
/* eslint-disable no-new */

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});

new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js